(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[513],{

/***/ 35582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; },
/* harmony export */   "s": function() { return /* binding */ OpenGraphType; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var lib_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22498);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


 // NOTE: copied from next-seo since it doesn't export this type.



var OpenGraphType;

(function (OpenGraphType) {
  OpenGraphType["WEBSITE"] = "website";
  OpenGraphType["ARTICLE"] = "article";
})(OpenGraphType || (OpenGraphType = {}));

var Meta = function Meta(_ref) {
  var titlePrefix = _ref.titlePrefix,
      _ref$titleSeparator = _ref.titleSeparator,
      titleSeparator = _ref$titleSeparator === void 0 ? '|' : _ref$titleSeparator,
      _ref$titleSuffix = _ref.titleSuffix,
      titleSuffix = _ref$titleSuffix === void 0 ? lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_NAME */ .px : _ref$titleSuffix,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? OpenGraphType.WEBSITE : _ref$type,
      description = _ref.description,
      _ref$seo = _ref.seo,
      seo = _ref$seo === void 0 ? {
    openGraph: {
      images: []
    }
  } : _ref$seo,
      _ref$relativeUrl = _ref.relativeUrl,
      relativeUrl = _ref$relativeUrl === void 0 ? '' : _ref$relativeUrl;
  var title = "".concat(titlePrefix, " ").concat(titleSeparator, " ").concat(titleSuffix);
  var url = "".concat("https://www.cutintothejamstack.com").concat(relativeUrl);

  var openGraph = _objectSpread({
    url: url,
    title: title,
    description: description,
    site_name: lib_constants__WEBPACK_IMPORTED_MODULE_3__/* .SITE_NAME */ .px,
    type: type
  }, seo.openGraph);

  var twitter = _objectSpread({
    handle: '@mcavaliere',
    cardType: 'summary'
  }, seo.twitter);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, _objectSpread({
      title: title,
      description: description,
      openGraph: openGraph,
      twitter: twitter
    }, seo))
  });
};

/***/ }),

/***/ 79102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ MaxWidthContainer; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40639);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MaxWidthContainer = function MaxWidthContainer(_ref) {
  var children = _ref.children,
      rest = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, _objectSpread(_objectSpread({
    maxW: "5xl",
    w: "100%"
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 94115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ChapterContents": function() { return /* binding */ ChapterContents; },
  "ChapterHeading": function() { return /* binding */ ChapterHeading; },
  "ComingSoon": function() { return /* binding */ ComingSoon; },
  "ComingSoonTag": function() { return /* binding */ ComingSoonTag; },
  "NewTag": function() { return /* binding */ NewTag; },
  "SectionLabel": function() { return /* binding */ SectionLabel; },
  "TOC": function() { return /* binding */ TOC; },
  "default": function() { return /* binding */ toc; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(40639);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-context/dist/index.esm.js
var react_context_dist_index_esm = __webpack_require__(28387);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 4 modules
var system_dist_index_esm = __webpack_require__(15818);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var styled_system_dist_index_esm = __webpack_require__(54520);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
// ../../../react-shim.js


// src/tag.tsx



var [TagStylesProvider, useTagStyles] = (0,react_context_dist_index_esm/* createContext */.k)({
  name: `TagStylesContext`,
  errorMessage: `useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tag />" `
});
var Tag = (0,system_dist_index_esm/* forwardRef */.Gp)((props, ref) => {
  const styles = (0,system_dist_index_esm/* useMultiStyleConfig */.jC)("Tag", props);
  const ownProps = (0,styled_system_dist_index_esm/* omitThemingProps */.Lr)(props);
  const containerStyles = {
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%",
    ...styles.container
  };
  return /* @__PURE__ */ react.createElement(TagStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react.createElement(system_dist_index_esm/* chakra.span */.m$.span, {
    ref,
    ...ownProps,
    __css: containerStyles
  }));
});
Tag.displayName = "Tag";
var TagLabel = (0,system_dist_index_esm/* forwardRef */.Gp)((props, ref) => {
  const styles = useTagStyles();
  return /* @__PURE__ */ react.createElement(system_dist_index_esm/* chakra.span */.m$.span, {
    ref,
    noOfLines: 1,
    ...props,
    __css: styles.label
  });
});
TagLabel.displayName = "TagLabel";
var TagLeftIcon = (0,system_dist_index_esm/* forwardRef */.Gp)((props, ref) => /* @__PURE__ */ react.createElement(dist_index_esm/* Icon */.JO, {
  ref,
  verticalAlign: "top",
  marginEnd: "0.5rem",
  ...props
}));
TagLeftIcon.displayName = "TagLeftIcon";
var TagRightIcon = (0,system_dist_index_esm/* forwardRef */.Gp)((props, ref) => /* @__PURE__ */ react.createElement(dist_index_esm/* Icon */.JO, {
  ref,
  verticalAlign: "top",
  marginStart: "0.5rem",
  ...props
}));
TagRightIcon.displayName = "TagRightIcon";
var TagCloseIcon = (props) => /* @__PURE__ */ react.createElement(dist_index_esm/* Icon */.JO, {
  verticalAlign: "inherit",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ react.createElement("path", {
  fill: "currentColor",
  d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
}));
TagCloseIcon.displayName = "TagCloseIcon";
var TagCloseButton = (0,system_dist_index_esm/* forwardRef */.Gp)((props, ref) => {
  const { isDisabled, children, ...rest } = props;
  const styles = useTagStyles();
  const btnStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "0",
    ...styles.closeButton
  };
  return /* @__PURE__ */ react.createElement(system_dist_index_esm/* chakra.button */.m$.button, {
    ref,
    "aria-label": "close",
    ...rest,
    type: "button",
    disabled: isDisabled,
    __css: btnStyles
  }, children || /* @__PURE__ */ react.createElement(TagCloseIcon, null));
});
TagCloseButton.displayName = "TagCloseButton";


// EXTERNAL MODULE: ./components/HeadContent/index.tsx
var HeadContent = __webpack_require__(35582);
// EXTERNAL MODULE: ./components/MaxWidthContainer/index.tsx
var MaxWidthContainer = __webpack_require__(79102);
// EXTERNAL MODULE: ./layouts/SiteOuterLayout.tsx + 66 modules
var SiteOuterLayout = __webpack_require__(61607);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./layouts/TocLayout.tsx




var TocLayout = function TocLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MaxWidthContainer/* MaxWidthContainer */.a, {
      my: 20,
      children: children
    })
  });
};
var getLayout = function getLayout(page) {
  return (0,SiteOuterLayout/* getLayout */.G0)( /*#__PURE__*/(0,jsx_runtime.jsx)(TocLayout, {
    children: page
  }));
};
/* harmony default export */ var layouts_TocLayout = ((/* unused pure expression or super */ null && (TocLayout)));
;// CONCATENATED MODULE: ./pages/toc.tsx






var LIST_LEFT_MARGIN_MULTIPLIER = 10;
var ChapterHeading = function ChapterHeading(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
    size: "lg",
    as: "h2",
    color: "brand.red",
    mb: 5,
    children: children
  });
};
var ChapterContents = function ChapterContents(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    ml: LIST_LEFT_MARGIN_MULTIPLIER * 1,
    mb: 5,
    children: children
  });
};
var SectionLabel = function SectionLabel(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
    as: "h3",
    children: children
  });
};
var ComingSoon = function ComingSoon(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
    opacity: 0.5,
    children: children
  });
};
var ComingSoonTag = function ComingSoonTag() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
    size: "lg",
    variant: "subtle",
    colorScheme: "red",
    mb: 2,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagLabel, {
      fontWeight: "bold",
      color: "brand.red",
      backgroundColor: "brand.fadedRed",
      children: "COMING SOON"
    })
  });
};
var NewTag = function NewTag() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
    size: "lg",
    variant: "subtle",
    mb: 2,
    colorScheme: "green",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagLabel, {
      fontWeight: "bold",
      children: "\uD83D\uDE80 JUST ADDED! \uD83D\uDE80"
    })
  });
};
function TOC() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeadContent/* Meta */.h, {
      relativeUrl: "/toc",
      titlePrefix: "Table of Contents",
      description: "Full table of contents for the book, Cut Into The Jamstack: Build and Deploy a Full-Stack Application with React and Next.js.",
      type: HeadContent/* OpenGraphType.ARTICLE */.s.ARTICLE,
      images: [{
        url: "".concat("https://www.cutintothejamstack.com", "/cutintothejamstack-logo-inline.png"),
        width: 456,
        height: 100,
        alt: 'Cut Into The Jamstack Logo'
      }]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
      mb: 10,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
        size: "xl",
        as: "h1",
        children: "Table of Contents"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
      children: "About this Beta"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
      children: "The What and Why"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "What you\u2019ll learn in this book"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Who this book is for"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "What you should know before reading this book"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Tools and libraries we chose and why"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Conventions used in this book"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "The app we\u2019ll be building"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
      children: "Laying Our Foundation"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "System Prerequisites"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Setting up our environment"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Folder Structure"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Setting up Chakra-UI"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Configuring Prisma"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
      children: "Building a Full-Stack Screen"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "How we\u2019ll build our first screen: steps"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Creating our first database table"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Seeding the database"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Creating our dashboard API endpoint"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Starting our dashboard page"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Adding some visual elements with Chakra-UI"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
      children: "Shipping to Production"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Ship, Ship, Ship - Going to Production"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Our hosting providers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "How deployment will work"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Configuring our setup for deployment"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Push the red button: let\u2019s deploy! \uD83D\uDE80"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Git branch strategy"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
      children: "Full-Stack Gallery CRUD"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Gallery CRUD"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Planning Gallery API endpoints"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Structure of Our CRUD Endpoints"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Gallery Creation API Endpoint"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Gallery Retrieval API Endpoint"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Gallery Update API Endpoint"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Gallery Deletion API Endpoint"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Planning Gallery CRUD UI"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "The GalleryListItem Component"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "The GalleryCreateModal Component"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "The GalleryEditModal Component"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "The GalleryDeleteDialog Component"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Creating an API Layer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Creating a Reusable Error Component"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "The Connected Dashboard"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Connecting the GalleryCreateModal and ErrorAlert"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Connecting the GalleryEditModal"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Enabling Gallery Deletion"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NewTag, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
      children: "Photo Gallery and Image Uploads"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Image Architecture Planning"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Configuring Cloudinary"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Important Cloudinary Links"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Configuring Cloudinary"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Adding Image Support to Our Database"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Building the Photo Gallery Page"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "DRYing up API Routes With Custom Middleware"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Building Photo API Endpoints"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Adding the Front-End API Layer"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Transforming iOS-Specific File Formats"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Adding Single-File Image Uploads to the Gallery Editor"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
        children: "Adding Photo Deletion to the Gallery Editor"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ComingSoonTag, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(ComingSoon, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
        children: "Photo Gallery Sharing"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Adding Public Gallery Routes"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Planning for UI Reuse"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Separating Gallery Editor and Public Gallery"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Adding Gallery Sharing"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
        children: "Authentication and Access Control"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Overview: Authentication and Access Control"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Configuring our hosting providers for authentication"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "How authentication will work"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "How access control will work"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "About next-auth"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Creating & Configuring OAuth Provider Accounts"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Installing and Configuring next-auth"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Requiring authentication with our screens"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Requiring authentication in our API endpoints"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Restricting users to resources they control"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Changing navbar state based on whether user is logged in"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ChapterHeading, {
        children: "$$$: Payment Processing w/Stripe"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ChapterContents, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Loading Stripe Dependencies"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Paid / Unpaid User Access"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "How Checkout Flow Will Work"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Creating & Configuring a Stripe Account For Subscriptions"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Configuring Stripe Locally & on Vercel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Adding a Stripe API Endpoint"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Connecting the UI to Stripe Checkout"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Saving Stripe Info to Associate With Users"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionLabel, {
          children: "Restricting Access For Unpaid Users in the API"
        })]
      })]
    })]
  });
}
TOC.getLayout = getLayout;
/* harmony default export */ var toc = (TOC);

/***/ }),

/***/ 42959:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toc",
      function () {
        return __webpack_require__(94115);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(42959); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);